export default "<div class=\"pb__tab\" *ngIf=\"shouldDisplay\"><ng-content></ng-content></div>\n"